import { render, staticRenderFns } from "./Seo.vue?vue&type=template&id=2052c7be&scoped=true"
import script from "./Seo.vue?vue&type=script&lang=js"
export * from "./Seo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2052c7be",
  null
  
)

export default component.exports